.noData {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 2rem;
}

.image {
	width: 150px;
	height: auto;
	margin-bottom: 1rem;
	opacity: 0.85;
}

.text {
	font-size: 1.125rem;
	color: #5f493c;
	font-weight: 500;
}
